module.exports = __webpack_public_path__ + "assets/91063c759cfe7db11f956a741c9a64f2.svg";